import React from 'react';
import { Home, Compass, Map, Settings } from 'lucide-react';
import { motion } from 'framer-motion';
interface BottomNavProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
}
export function BottomNav({
  activeTab,
  onTabChange
}: BottomNavProps) {
  const tabs = [{
    id: 'home',
    icon: Home,
    label: 'Home'
  }, {
    id: 'explore',
    icon: Compass,
    label: 'Explore'
  }, {
    id: 'maps',
    icon: Map,
    label: 'Maps'
  }, {
    id: 'settings',
    icon: Settings,
    label: 'Settings'
  }];
  const activeIndex = tabs.findIndex(tab => tab.id === activeTab);
  return <div className="fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-900 border-t border-gray-100 dark:border-gray-800 px-6 py-3 pb-6 z-50 transition-colors duration-200" data-id="element-10">
      <div className="max-w-md mx-auto relative" data-id="element-11">
        {/* Sliding indicator */}
        <motion.div className="absolute top-0 h-0.5 bg-[#00D084] rounded-full" animate={{
        left: `${activeIndex * 25}%`,
        width: '25%'
      }} transition={{
        type: 'spring',
        stiffness: 380,
        damping: 30
      }} data-id="element-12" />

        <div className="flex justify-between items-center pt-2" data-id="element-13">
          {tabs.map(tab => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          return <motion.button key={tab.id} onClick={() => onTabChange(tab.id)} className={`flex flex-col items-center gap-1 transition-colors duration-200 ${isActive ? 'text-[#00D084]' : 'text-gray-400 dark:text-gray-500'}`} whileTap={{
            scale: 0.9
          }} transition={{
            duration: 0.1
          }} data-id="element-14">
                <motion.div animate={{
              scale: isActive ? 1.1 : 1
            }} transition={{
              duration: 0.2
            }} data-id="element-15">
                  <Icon className={`w-6 h-6 ${isActive ? 'fill-current' : ''}`} strokeWidth={isActive ? 2.5 : 2} data-id="element-16" />
                </motion.div>
                <span className="text-[10px] font-medium" data-id="element-17">{tab.label}</span>
              </motion.button>;
        })}
        </div>
      </div>
    </div>;
}